import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const InpcActionsEdit = ({ inpc, company, t, handleClick = () => {} }) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={`/companies/${company.id}/inpc/${inpc.id}/edit`}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(InpcActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/list/actions/InpcActionEdit.js